import { atom, useAtom, useSetAtom } from "jotai";

export const mapIdAtom = atom("");
const useMapId = () => {
  const atom = useAtom(mapIdAtom);
  return atom;
};

export const useSetMapId = () => useSetAtom(mapIdAtom);

export default useMapId;
